import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import animation_celebration from './Animation/animation_celebration.json';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import icon120 from '../LeadSuccess/Image/icon-120.svg';
import './foundFiberSuccess.scss';

const FoundFiberSuccess = (props) => {
  const getData = () => {
    return `${props.selectedAddress.streetName} ${props.selectedAddress.home}, ${props.selectedAddress.cityName}`;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      props.onValid({ valid: true });
    }, 3000);
    gtag4({
      event: `${props.saleType}_Step3_SivimExistsPage`,
      step: '3',
      action: 'SivimExistsPage',
      funnel_name: 'Sivim_Exists',
    });
    return () => clearTimeout(timer);
  }, []);

  const defaultOptions = {
    loop: 0,
    autoplay: true,
    animationData: animation_celebration,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <div className='found-fiber-success'>
      <Lottie
        className='animation-celebration'
        options={defaultOptions}
        style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translateX(-50%) translateY(-50%)' }}
        height={400}
        width={400}
      />
      <div className='icon-position'>
        <div className='icon-img' style={{backgroundImage:icon120.bg()}}></div>
      </div>
      <div className='text-of-success'>
        <p>
          איזה כיף! <br />
          יש לנו רשת סיבים מוכנה <br />
          בכתובת: {getData()}
        </p>
      </div>
    </div>
  );
};

export default FoundFiberSuccess;
